import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  name: 'Valentina R.',
  city: 'Rosario'
}, {
  name: 'Luciana M.',
  city: 'Mendoza'
}, {
  name: 'Florencia G.',
  city: 'Tucumán'
}, {
  name: 'Romina P.',
  city: 'Paraná'
}, {
  name: 'Agustina D.',
  city: 'Salta'
}, {
  name: 'Camila T.',
  city: 'Neuquén'
}, {
  name: 'Daniela F.',
  city: 'Posadas'
}, {
  name: 'Sofía B.',
  city: 'Resistencia'
}, {
  name: 'Antonella V.',
  city: 'La Plata'
}, {
  name: 'Belén O.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta C.',
  city: 'San Juan'
}, {
  name: 'Micaela H.',
  city: 'Bariloche'
}, {
  name: 'Paula E.',
  city: 'Santiago del Estero'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 2;
}
function getRandomIndex(exclude: number) {
  let next = Math.floor(Math.random() * PURCHASES.length);
  while (next === exclude && PURCHASES.length > 1) {
    next = Math.floor(Math.random() * PURCHASES.length);
  }
  return next;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * PURCHASES.length));
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // First popup appears after 4s
    const initial = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Show for 4s
    const hide = setTimeout(() => {
      setVisible(false);
      // Show next after 3s gap → total cycle ~ 7s
      const showNext = setTimeout(() => {
        setCurrentIndex(prev => getRandomIndex(prev));
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, 3000);
      return () => clearTimeout(showNext);
    }, 4000);
    return () => clearTimeout(hide);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-302" data-mp="1m44smcs3o85p">
      <div className="bg-[#ffffff] border border-[#2E4F48]/15 rounded-xl p-3.5 shadow-lg" data-id="element-303" data-mp="1vuzf9i99d9ro">
        <div className="flex items-start gap-3" data-id="element-304" data-mp="20ry4bme2eqj0">
          <div className="w-9 h-9 rounded-full bg-[#C2683D]/15 border border-[#C2683D]/30 flex items-center justify-center flex-shrink-0" data-id="element-305" data-mp="24tt4gnk9exv7">
            <span className="text-sm" data-id="element-306" data-mp="29uh4tzudor23">✨</span>
          </div>
          <div className="min-w-0" data-id="element-307" data-mp="2es0ioyn5z1ti">
            <p className="text-[#1C3B36] text-sm font-semibold leading-tight" data-id="element-308" data-mp="2eqxvb0p1vhic">
              {purchase.name}
              <span className="text-[#44574F] font-normal" data-id="element-309" data-mp="fgppqkta5ez9"> de </span>
              <span className="text-[#C2683D]" data-id="element-310" data-mp="kdg515x9g6jm">{purchase.city}</span>
            </p>
            <p className="text-[#44574F] text-xs mt-0.5" data-id="element-311" data-mp="cv8gu9zhiaq0">
              adquirió la{' '}
              <span className="text-[#1C3B36] font-semibold" data-id="element-312" data-mp="849zr86o98lp">
                Formación en Biodescodificación
              </span>
            </p>
            <p className="text-[#44574F] text-[10px] mt-1" data-id="element-313" data-mp="35ouuvgh60qx">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}